var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2828 16.8249C9.67288 16.8072 9.10673 16.5022 8.77478 16.0191L6.35004 12.669C6.06962 12.2816 6.15637 11.7402 6.5438 11.4598C6.93123 11.1794 7.47263 11.2661 7.75305 11.6535L10.1898 15.0206C10.2191 15.0631 10.2725 15.0919 10.3332 15.0937C10.3943 15.0955 10.4505 15.0694 10.483 15.0277L10.5647 14.937L17.3371 8.40845C17.6815 8.07652 18.2297 8.08658 18.5616 8.43091C18.8935 8.77524 18.8835 9.32345 18.5392 9.65538L11.804 16.1479C11.4298 16.5922 10.8686 16.842 10.2828 16.8249ZM12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM12 22.5941C17.851 22.5941 22.5941 17.851 22.5941 12C22.5941 6.14902 17.851 1.40586 12 1.40586C6.14902 1.40586 1.40586 6.14902 1.40586 12C1.40586 17.851 6.14902 22.5941 12 22.5941Z",
    fill: "#162056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.54b14b1d17a0eb7b62e694b2e5d5d359.svg";
export { ForwardRef as ReactComponent };